import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';

var _excluded = ["title", "pathRest"];
var IconClose = function IconClose(_ref) {
  var title = _ref.title,
    pathRest = _ref.pathRest,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hci-svg-close"
  }, rest), title && /*#__PURE__*/React__default.createElement("title", null, title), /*#__PURE__*/React__default.createElement("path", _extends({
    d: "m13.41 12 6.37-6.36a1 1 0 1 0-1.42-1.42L12 10.6 5.64 4.22a1 1 0 1 0-1.42 1.42L10.6 12l-6.37 6.36a1 1 0 1 0 1.42 1.42L12 13.4l6.36 6.37a1 1 0 1 0 1.42-1.42z"
  }, pathRest)));
};
IconClose.displayName = 'InlineIcon(IconClose)';
IconClose.propTypes = {
  title: PropTypes__default.string,
  pathRest: PropTypes__default.object
};

export { IconClose };
